module.exports = __webpack_public_path__ + "img/beyond.927e785d.png";